import {
  createResourceQueryAtom,
  defineResource,
  defineResourceQuery,
} from "#/shared/lib/resource";

import { startPlaygroundSession } from "../api/start-playground-session";
import {
  readPlaygroundUid,
  readPlaygroundResetUid,
  completePlaygroundReset,
  rememberPlaygroundUid,
} from "../lib/playground-uid";

const playgroundResource = defineResource("playground");

/**
 * 开会话是 POST，但读起来像一次取数：进页面拿一个 uid 和首屏示例问题，
 * 之后一直用它。所以走 query 而不是 mutation。
 * 每次取数都带上已有的 uid，所以窗口重新聚焦、切走再回来都只是换一份新令牌，
 * 对话还在；New test 优先提交旧访客撤销，再创建匿名测试。
 */
const playgroundSessionQuery = defineResourceQuery({
  key: () => [],
  name: "session",
  queryFn: () => {
    const resetUid = readPlaygroundResetUid();
    return startPlaygroundSession({
      uid: resetUid ? undefined : readPlaygroundUid(),
      resetUid,
    }).map((session) => {
      completePlaygroundReset(resetUid);
      rememberPlaygroundUid(session.uid);
      return session;
    });
  },
  resource: playgroundResource,
  staleTime: 300_000,
});

export const playgroundSessionAtom = createResourceQueryAtom(
  playgroundSessionQuery,
  () => undefined,
);
